(function(){
  angular.module('EdxClassroomReportModule')
    .directive('edxStudentAlertsTable', function() {
      return {
        restrict: 'E',
        scope: {
          edxStudentAlerts: '=',
          edxNoAlertsMessage: '='
        },
        templateUrl: '/resources/components/report/classroom/at-a-glance/student-alerts-table.directive.html',
        controller: ['navigation', StudentAlertsTableController],
        controllerAs: 'vm',
        bindToController: true
      };
    });

  function StudentAlertsTableController(navigation) {
    var vm = this;
    vm.onStudentNameClicked = onStudentNameClicked;
    _onInit();

    // noinspection UnnecessaryReturnStatementJS
    return;

    function _onInit() {

    }

    function onStudentNameClicked(student) {
      navigation.goToItem({type: 'student', id: student.id});
    }
  }

})();